export const UserRoles = [
  { key: "Admin", value: "admin" },
  { key: "User", value: "user" },
  { key: "Salesperson", value: "salesperson" },
  { key: "Accountant", value: "accountant" },
  { key: "Warehouseman", value: "warehouseman" },
];
